export function extractEnumValues<X>(enumm: X) {
  const values = Object.values(enumm!)
  return values.filter((el) => typeof el === 'number') as X[]
}
